import React from 'react';
import TopicCard from './TopicCard';

const TopicList = ({ topics }) => {
  return (
    <div className="grid gap-6 grid-cols-[repeat(auto-fit,minmax(280px,340px))]">
      {topics.map((topic) => (
        <TopicCard key={topic.id} topic={topic} />
      ))}
    </div>
  );
};

export default TopicList;
